/*
 * we sometimes want for our styled-components to not pass through specific props
 * to the component they are extending from. This function should be passed into the
 * withConfig option from the extended component. something like:
 * const MaterialMenu = styled(MaterialMenuDefault).withConfig(
 *  captureProps(['dense'])
 * );
 */
/*tslint:disable:ban-types*/
export const capturePropsUtil = (propsToCapture: String | String[]) => {
  if (Array.isArray(propsToCapture)) {
    return {
      shouldForwardProp: (prop: String) => !propsToCapture.includes(prop),
    };
  } else {
    return {
      shouldForwardProp: (prop: String) => propsToCapture !== prop,
    };
  }
};
